// extracted by mini-css-extract-plugin
export default {"buttonsWrapper":"ModalConfirm_buttonsWrapper__RQXjU","modal":"ModalConfirm_modal__r6qXW"};